import React from 'react';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { colunasTabelaPrecoVendedor } from './config/configColunasTabela';

const dynamicColumns = cols => cols.map(col => <Column filter key={col[0]} field={col[0]} header={col[1]} body={col[2]} bodyStyle={col[3]} />);

export default function DataTableTabelaPreco({ states, setters }) {
    const {
        paginaAtualDataTable,
        itensPorPaginaDataTable,
        primeiroItenParaMostrarDataTable,
        dadosTabela,
        tipoPesquisa,
        loadingTabela
    } = states;

    const {
        setPaginaAtualDataTable,
        setPaginasTotaisDataTable,
        setItensPorPaginaDataTable,
        setPrimeiroItenParaMostrarDataTable,
        setPaginaAnterior } = setters;

    return <>
        <div className='datatable-responsive-demo'><DataTable
            className="p-datatable-responsive-demo"
            value={dadosTabela}
            paginator={true}
            rowsPerPageOptions={[10, 20, 50]}
            rows={itensPorPaginaDataTable}
            onPage={e => {
                const paginaAtual = paginaAtualDataTable;

                setPrimeiroItenParaMostrarDataTable(e.first);
                setPaginaAtualDataTable(e.page);
                setPaginasTotaisDataTable(e.pageCount - 1);
                setItensPorPaginaDataTable(e.rows);
                setPaginaAnterior(paginaAtual);
            }}
            first={primeiroItenParaMostrarDataTable}
            loading={loadingTabela}
        >
            {dynamicColumns(colunasTabelaPrecoVendedor[tipoPesquisa.toLowerCase()])}
        </DataTable></div>
    </>;
}
